import { createContext } from 'react';

const ThemeProviderContext = createContext({});

export default ThemeProviderContext;
